module.exports = __webpack_public_path__ + "media/images/icon/copy-f87c6b4f64d31bd3fdef4082c564ed88.svg";